import React, { useEffect, useRef } from "react";

export default function ScrollToDivOnMount(props: { children?: React.ReactNode }) {
    const divRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        divRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);
    return <div ref={divRef}>{props.children}</div>;
}
